import React from 'react';
import { Row, Col } from 'react-flexbox-grid'
import { withStyles } from '@material-ui/core/styles';
import InputBase from '@material-ui/core/InputBase';
import InputAdornment from '@material-ui/core/InputAdornment';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import Typography from '@material-ui/core/Typography';
import {
    Close as CloseIcon,
    Clear as ClearIcon,
    ExpandMore as ExpandMoreIcon,
    ViewModule as ViewModuleIcon,
    ArrowBackIos as ArrowBackIcon,
} from '@material-ui/icons';
import CircularProgress from '@material-ui/core/CircularProgress';
import './styles.css'

const styles = theme => ({
    rootDialog:{
        zIndex: '1505 !important',
    },
    rootContent:{
        background: '#FFFFFF 0% 0% no-repeat padding-box',
        boxShadow: '-5px 4px 10px #8E8E8E29',
        borderRadius: '21px',
        opacity: 1,
        maxWidth: '850px',
        minWidth: '290px',
        padding: '0px !important',
        overflow: 'hidden',
    },
    rootRadioGroup:{
        display: 'flex',
        justifyContent: 'center',
        flexDirection: 'column',
        width: '120px',
    },
    rootFormLabel:{
        marginLeft: '0px',
        marginRight: '0px'
    },
    heading: {
        fontSize: theme.typography.pxToRem(15),
        fontWeight: theme.typography.fontWeightRegular,
    },
})

class SearchHeader extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            isMobile: this.isMobile(),
            isInputFocused: false,
        }
    }
    
    componentDidMount = () => {
        window.addEventListener('resize', this.handleResize);
    }

    componentWillUnmount = () => {
        window.removeEventListener('resize', this.handleResize);
    }

    handleResize = () => {
        const isMobile = this.isMobile();
        
        if (isMobile !== this.state.isMobile) {
            this.setState({ isMobile });
        }
    }

    isMobile = () => (window.innerWidth < 768);

    onInputFocus = () => this.setState({ isInputFocused: true })

    onInputBlur = () => this.setState({ isInputFocused: false })

    toFixedCustomize = (num) => {
        var resultado = num.toFixed(6).slice(0,-4)
        return resultado
    }

  render() {

    const { classes } = this.props
    
    return (
        <div className={`buscadorContainer ${this.props.pedido ? 'buscadorWithResumen inputSeatchAux' : ''}`}>
            <InputBase
                className='inputSearch'
                placeholder="Buscar"
                onChange={this.props.handleOnChangeFilter}
                onFocus={this.onInputFocus}
                onBlur={() => setTimeout(this.onInputBlur)}
                value={this.props.filterArticulos ? this.props.filterArticulos : ''}
                endAdornment={
                <InputAdornment position="end">
                <div style={{marginRight: '20px', cursor: 'pointer', display: 'flex'}}>
                    <img alt='' src={require('../../images/iconSearch.svg')}></img>
                </div>
                {this.props.filterArticulos !== undefined && <div className='iconClearBusqueda'>
                    <ClearIcon onClick={this.props.handleOnClearBusqueda}/>
                </div>}
                </InputAdornment>}
            />

            { (!this.state.isMobile || !this.state.isInputFocused) && (
                <>
                    <div className={`btn btnCategorias ${this.props.pedido ? 'btnCategoriasAux' : ''}`} onClick={this.props.handleOnClickOpenModalRubros}>
                        <ViewModuleIcon />
                        <div className='label'>Categorias</div>
                    </div>

                    {/* <div className="btn btnOfertas" onClick={this.props.handleOnClickOpenModalOfertas}>
                        <LocalOfferIcon />
                        <div className='label'>Ofertas</div>
                    </div> */}
                </>
            )}

            { this.state.isMobile && this.state.isInputFocused && (
                <div className="btn arrowBack">
                    <ArrowBackIcon />
                </div>
            )}

            {/* MODAL RUBROS */}
            <Dialog
                classes={{root: classes.rootDialog, paperScrollPaper: classes.rootContent}}
                open={this.props.openModalRubros}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                maxWidth='sm'
                fullWidth={true}
            >
                <DialogContent classes={{root: classes.rootContent}}>
                    <Row style={{margin: '0px'}}>

                        <Col  xs={12} md={12} lg={12}  style={{padding: '0px'}}>
                            <div className='containerModal'>

                                <div className='containerTitle'>
                                    <div className='label'>
                                        Categorías
                                    </div>
                                    <div style={{display: 'flex'}}>
                                        <CloseIcon cursor='pointer' fontSize='medium' onClick={this.props.handleOnClickCloseModalRubros}/>
                                    </div>
                                </div>

                                {this.props.rubrosSubrubros === undefined &&
                                    <div className='loader'>
                                        <CircularProgress />
                                    </div>
                                }
                                
                                {this.props.rubrosSubrubros && <div id='expandedRubros' className='containerRubros'>
                                    {this.props.rubrosSubrubros.length > 0 && this.props.rubrosSubrubros.map((r, i) => {
                                        return (
                                        <div key={i} style={{width: '100%'}}>
                                            <ExpansionPanel>
                                                <ExpansionPanelSummary
                                                    className='panelRubro'
                                                    expandIcon={<ExpandMoreIcon style={{color: '#FFFFFF'}} />}
                                                    aria-controls={`panel${r.idRubro}a-content`}
                                                    id={`panel${r.idRubro}a-header`}
                                                    >
                                                    <Typography className={`${classes.heading} labelRubro`}>{r.nombre}</Typography>
                                                </ExpansionPanelSummary>
                                                <ExpansionPanelDetails style={{padding: '0px'}}>
                                                    <div style={{width: '100%'}}>
                                                        {r.subrubros && r.subrubros.map((s, ind) => {
                                                            return <div key={ind} className='labelSubrubro' onClick={() => {this.props.handleOnClickSubrubro(s)}}>
                                                                        {s.esRubro === true ? 'Todos los articulos de ' + s.nombre : s.nombre}
                                                                    </div>
                                                        })}
                                                    </div>
                                                </ExpansionPanelDetails>
                                            </ExpansionPanel>
                                        </div>)
                                    })}
                                </div>}

                                {this.props.rubrosSubrubros && this.props.rubrosSubrubros.length === 0 &&
                                    <div className='labelNoEncontrado'>No se encontraron categorías para mostrar</div>
                                }
                            </div>
                        </Col>
                    </Row>
                </DialogContent>
            </Dialog>

            {/* MODAL OFERTAS */}
            <Dialog
                classes={{root: classes.rootDialog, paperScrollPaper: classes.rootContent}}
                open={this.props.openModalOfertas}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                maxWidth='sm'
                fullWidth={true}
            >
                <DialogContent classes={{root: classes.rootContent}}>
                    <Row style={{margin: '0px'}}>

                        <Col  xs={12} md={12} lg={12}  style={{padding: '0px'}}>
                            <div className='containerModal'>

                                <div className='containerTitle'>
                                    <div className='label'>
                                        Ofertas
                                    </div>
                                    <div style={{display: 'flex'}}>
                                        <CloseIcon cursor='pointer' fontSize='medium' onClick={this.props.handleOnClickCloseModalOfertas}/>
                                    </div>
                                </div>

                                {this.props.ofertas === undefined &&
                                    <div className='loader'>
                                        <CircularProgress />
                                    </div>
                                }
                                
                                { this.props.ofertas && (
                                    <div className="containerOfertas">
                                        { this.props.ofertas.map((o, i) => (
                                            <ExpansionPanelDetails key={i} style={{padding: '0px'}}>
                                                <div className='ofertaItem' onClick={() => {this.props.handleOnClickOferta(o)}}>
                                                    <Typography className={`${classes.heading} label`}>{o.nombre}</Typography>
                                                </div>
                                            </ExpansionPanelDetails>
                                        ))}
                                    </div>
                                )}

                                {this.props.ofertas && this.props.ofertas.length === 0 &&
                                    <div className='labelNoEncontrado'>No se encontraron ofertas para mostrar</div>
                                } 
                            </div>
                        </Col>
                    </Row>
                </DialogContent>
            </Dialog>
        </div>
    );
  }
}


export default withStyles(styles)(SearchHeader);

